import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AdminHome from '../views/AdminHome.vue'
import Splash from '../views/Splash.vue'
import Login from '../views/auth/Login'
import DailyFunctionality from '../views/functionality/DailyFunctionality.vue'
import EmptyView from '../views/EmptyView.vue'
import store from '../store'
import EosUtils from '../utils/EosUtils'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'splash',
    component: Splash
  },
  // {
  //   path: '/',
  //   name: 'login',
  //   component: Login
  // },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  /**
   * admin
   */
  {
    path: '/adminHome',
    name: 'adminHome',
    component: AdminHome,
    meta: {
      requiresAuth: true,
      userRole: 'admin'
    },
    children: [
      /**
       * adminMainPage
       */
      {
        path: 'adminMainPage',
        name: 'adminMainPage',
        components: { adminPlaceholder: () => import('@/views/admin/adminMainPage.vue') },
        meta: { toolbarTitle: 'nav-main' }
      },
      {
        path: 'adminPersonelsSection',
        name: 'adminPersonelsSection',
        components: { adminPlaceholder: () => import('../views/personelOperationReport/SectionPersonel.vue') },
        meta: { toolbarTitle: 'nav-personel-show' }
      },
      {
        path: 'personelProfile',
        name: 'personelProfile',
        components: { adminPlaceholder: () => import('@/views/profile/Profile.vue') },
        meta: { toolbarTitle: 'nav-profile' }
      },
      {
        path: 'admin-present-personel',
        name: 'admin-present-personel',
        components: { adminPlaceholder: () => import('../views/personelOperationReport/PresentPersonel.vue') },
        meta: { toolbarTitle: 'nav-present-personel' }
      },
      {
        path: 'admin-absence-report',
        name: 'admin-absence-report',
        components: {
          adminPlaceholder: () => import('../views/personelOperationReport/AbsencePersonel.vue'),
        },
        meta: { toolbarTitle: 'nav-absence-report' },
      },
      {
        path: 'adminPersonelioinfo',
        name: 'adminPersonelioinfo',
        components: {
          adminPlaceholder: () => import('../views/personelOperationReport/PersonelIoInfo.vue'),
        },
        meta: { toolbarTitle: 'nav-personelioinfo' },
      },
      {
        path: 'adminIoinfoindate',
        name: 'adminIoinfoindate',
        components: {
          adminPlaceholder: () => import('../views/personelOperationReport/IoInfoInDate.vue'),
        },
        meta: { toolbarTitle: 'nav-ioinfoindate' },
      },
      {
        path: 'admincompeleteioindate',
        name: 'admincompeleteioindate',
        components: {
          adminPlaceholder: () => import('../views/personelOperationReport/CompleteIOInDate.vue'),
        },
        meta: { toolbarTitle: 'nav-compeleteio-specificdate' },
      },
      {
        path: 'admincompeleteio',
        name: 'admincompeleteio',
        components: {
          adminPlaceholder: () => import('../views/personelOperationReport/CompleteIO.vue'),
        },
        meta: { toolbarTitle: 'nav-compeleteio' },
      },
      {
        path: 'publicAccess',
        name: 'publicAccess',
        components: {
          adminPlaceholder: () => import('../views/admin/publicAccess/PublicAccess.vue'),
        },
        meta: { toolbarTitle: 'nav-public-access' },
        props: true
      },
      /**
       * pattern
       */
      {
        path: 'add-pattern',
        name: 'add-pattern',
        components: {
          adminPlaceholder: () => import('../views/admin/pattern/AddPattern.vue'),
        },
        meta: { toolbarTitle: 'nav-add-pattern' },
      },
      {
        path: 'patternPermission',
        name: 'patternPermission',
        components: {
          adminPlaceholder: () => import('../views/admin/pattern/PatternPermission.vue'),
        },
        meta: { toolbarTitle: 'Pattern.patternPermission' },
      },
      {
        path: 'patternApproveCode',
        name: 'patternApproveCode',
        components: {
          adminPlaceholder: () => import('../views/admin/pattern/PatternApproveCode.vue'),
        },
        meta: { toolbarTitle: 'Pattern.patternPermission' },
      },
      /**
       * sectionPersonel
       */
      {
        path: 'sectionPersonelManagment',
        name: 'sectionPersonelManagment',
        components: {
          adminPlaceholder: () => import('../views/admin/sectionPersonel/SectionPersonelManagment.vue'),
        },
        meta: { toolbarTitle: 'nav-section-personel-management' },
      },
      {
        path: 'adminPermission',
        name: 'adminPermission',
        components: {
          adminPlaceholder: () => import('../views/admin/sectionPersonel/AdminPermission.vue'),
        },
        meta: { toolbarTitle: 'adminPermission' },
      },
      {
        path: 'pageApproveCode',
        name: 'pageApproveCode',
        components: {
          adminPlaceholder: () => import('../views/admin/sectionPersonel/PageApproveCode.vue'),
        },
        meta: { toolbarTitle: 'adminPermission' },
      },
      /**
       * request-management
       */
      {
        path: 'admin-vacation-management',
        name: 'admin-vacation-management',
        components: {
          adminPlaceholder: () => import('../views/requestManagement/VacationManagement.vue'),
        },
        meta: { toolbarTitle: 'nav-vacation-management' },
      },
      {
        path: 'request-leave',
        name: 'admin-request-leave',
        components: {
          adminPlaceholder: () => import('@/views/request/VacationRequest.vue')
        },
        meta: { toolbarTitle: 'nav-request-leave' },
      },
      {
        path: 'admin-mission-management',
        name: 'admin-mission-management',
        components: {
          adminPlaceholder: () => import('../views/requestManagement/MissionManagement.vue'),
        },
        meta: { toolbarTitle: 'nav-mission-management' },
      },
      {
        path: 'admin-io-management',
        name: 'admin-io-management',
        components: {
          adminPlaceholder: () => import('../views/requestManagement/IOManagement.vue'),
        },
        meta: { toolbarTitle: 'nav-io-management' },
      },
      {
        path: 'admin-extra-work-management',
        name: 'admin-extra-work-management',
        components: {
          adminPlaceholder: () => import('../views/requestManagement/ExtraWorkManagement.vue'),
        },
        meta: { toolbarTitle: 'nav-extra-work-management' },
      },
      {
        path: 'request-extra-work',
        name: 'admin-request-extra-work',
        components: {
          adminPlaceholder: () => import('@/views/request/ExtraWorkRequest.vue'),
        },
        meta: { toolbarTitle: 'nav-request-extra-work' },
      },
      /**
       * Functionality
       */
      {
        path: 'admin-personel-daywork',
        name: 'admin-personel-daywork',
        components: {
          adminPlaceholder: () => import('../views/personelOperationReport/PersonelDayWork.vue'),
        },
        meta: { toolbarTitle: 'nav-personeldaywork' },
      },
      {
        path: 'admin-personel-monthwork',
        name: 'admin-personel-monthwork',
        components: {
          adminPlaceholder: () => import('../views/personelOperationReport/PersonelMonthWork.vue'),
        },
        meta: { toolbarTitle: 'nav-personelmonthwork' },
      },
      {
        path: 'admin-personel-periodwork',
        name: 'admin-personel-periodwork',
        components: {
          adminPlaceholder: () => import('../views/personelOperationReport/PersonelPeriodWork.vue'),
        },
        meta: { toolbarTitle: 'nav-personelperiodwork' },
      },
      {
        path: 'PeriodWorkDetails',
        name: 'adminPeriodWorkDetails',
        components: {
          adminPlaceholder: () => import('@/views/functionality/PeriodWorkDetails.vue')
        },
        meta: { toolbarTitle: 'PeriodWorkDetails.toolbarTitle' },
      },
      {
        path: 'MonthWorkDetails',
        name: 'adminMonthWorkDetails',
        components: {
          adminPlaceholder: () => import('@/views/functionality/MonthWorkDetails.vue')
        },
        meta: { toolbarTitle: 'MonthWorkDetails.toolbarTitle' },
      },
      /**
       * Messages
       */
      {
        path: 'inbox',
        name: 'admin-inbox',
        components: {
          //default: EmptyView,
          adminPlaceholder: () => import('@/views/messages/Inbox.vue'),
        },
        meta: { toolbarTitle: 'nav-inbox' },
      },
      {
        path: 'outbox',
        name: 'admin-outbox',
        components: {
          //default: EmptyView,
          adminPlaceholder: () => import('@/views/messages/outbox.vue'),
        },
        meta: { toolbarTitle: 'nav-outbox' },
      },
      {
        path: 'send-message',
        name: 'admin-send-message',
        components: {
          //default: EmptyView,
          adminPlaceholder: () => import('@/views/messages/SendMessage.vue'),
        },
        meta: { toolbarTitle: 'nav-send-message' },
      },
      /**
       * webSettings
       */
      {
        path: 'webSettings',
        name: 'webSettings',
        components: {
          //default: EmptyView,
          adminPlaceholder: () => import('@/views/admin/settings/WebSettings.vue'),
        },
        meta: { toolbarTitle: 'nav-settings' },
      },
      /**
       * pass
       */
      {
        path: 'changePassword',
        name: 'admin-change-password',
        components: {
          //default: EmptyView,
          adminPlaceholder: () => import('@/views/pass/ChangePass.vue'),
        },
        meta: { toolbarTitle: 'nav-change-password' },
      },
      {
        path: 'resetPassword',
        name: 'admin-reset-password',
        components: {
          //default: EmptyView,
          adminPlaceholder: () => import('@/views/admin/pass/ResetPersonelPass.vue'),
        },
        meta: { toolbarTitle: 'nav-reset-password' },
      },
      /**
       * Active Directory
       */
      {
        path: 'activeDirectory',
        name: 'active-directory',
        components: {
          //default: EmptyView,
          adminPlaceholder: () => import('@/views/admin/activeDirectory/ActiveDirectory.vue'),
        },
        meta: { toolbarTitle: 'nav-active-directory' },
      },
      /**
       * Portal
       */
      // {
      //   path: 'portal',
      //   name: 'portal',
      //   components: {
      //     //default: EmptyView,
      //     adminPlaceholder: () => import('@/views/admin/portal/Portal.vue'),
      //   },
      //   meta: {
      //     toolbarTitle: 'nav-portal',
      //     requiresAuth: true,
      //     userRole: 'admin'
      //   },
      // },
      /**
       * Map
       */
      {
        path: 'eosMap',
        name: 'eosMap',
        components: {
          //default: EmptyView,
          adminPlaceholder: () => import('@/views/admin/map/EosMap.vue'),
        },
        meta: {
          toolbarTitle: 'nav-map',
          requiresAuth: true,
          userRole: 'admin'
        },
      },
    ]
  },

  /**
   * #272161
   * personel and manager
   */
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
    children: [
      /**
       * profile
       */
      {
        path: 'profile',
        name: 'profile',
        components: { mainPlaceholder: () => import('@/views/profile/Profile.vue') },
        meta: { toolbarTitle: 'nav-profile' }
      },
      {
        path: 'messages',
        name: 'messages',
        components: { mainPlaceholder: () => import('@/views/messages/Messages.vue') },
        meta: { toolbarTitle: 'messages' },
      },
      {
        path: 'absent-person',
        name: 'absentPerson',
        components: { mainPlaceholder: () => import('@/views/profile/AbsentPerson.vue') },
        meta: { toolbarTitle: 'absentPerson.absentPerson' },
        props: true,
      },
      // Access
      {
      path: 'accessPublic',
      name: 'accessPublic',
      components: {
        mainPlaceholder: () => import('../views/admin/publicAccess/PublicAccess.vue'),
      },
      // components: {
      //   adminPlaceholder: () => import('../views/accessPublic/AccessPublic.vue'),
      // },
      meta: { toolbarTitle: 'nav-public-access' },
      props: true
    },
      /**
       * IO
       */
      {
        path: 'interval-io',
        name: 'interval-io',
        components: { mainPlaceholder: () => import('@/views/io/IntervalIO.vue') },
        meta: { toolbarTitle: 'nav-interval-io' }
      },
      {
        path: 'monthly-io',
        name: 'monthly-io',
        components: { mainPlaceholder: () => import('@/views/io/MonthlyIO.vue') },
        meta: { toolbarTitle: 'nav-monthly-io' }
      },
      {
        path: 'interval-io-report',
        name: 'interval-io-report',
        components: { mainPlaceholder: () => import('@/views/io/IntervalIOReport.vue') },
        meta: { toolbarTitle: 'nav-interval-io-report' }
      },
      {
        path: 'monthly-io-report',
        name: 'monthly-io-report',
        components: { mainPlaceholder: () => import('@/views/io/MonthlyIOReport.vue') },
        meta: { toolbarTitle: 'nav-monthly-io-report' }
      },
      /**
       * functionality
       */
      {
        path: 'daily-functionality',
        name: 'daily-functionality',
        components: {
          //default: EmptyView,
          mainPlaceholder: DailyFunctionality
        },
        meta: { toolbarTitle: 'nav-functionality-daily' }
      },
      {
        path: 'eosDayWorkDetail',
        name: 'eosDayWorkDetail',
        components: { mainPlaceholder: () => import('../views/functionality/DayWorkDetails.vue') },
        meta: { toolbarTitle: 'nav-eosDayWorkDetail' }
      },
      {
        path: 'periodic-functionality',
        name: 'periodic-functionality',
        components: { mainPlaceholder: () => import('../views/functionality/periodicFunctionality.vue') },
        meta: { toolbarTitle: 'nav-functionality-periodic' },
      },
      {
        path: 'monthly-functionality',
        name: 'monthly-functionality',
        components: { mainPlaceholder: () => import('../views/functionality/monthlyFunctionality.vue') },
        meta: { toolbarTitle: 'nav-functionality-monthly' },
      },
      {
        path: 'PeriodWorkDetails',
        name: 'PeriodWorkDetails',
        components: { mainPlaceholder: () => import('@/views/functionality/PeriodWorkDetails.vue') },
        meta: { toolbarTitle: 'PeriodWorkDetails.toolbarTitle' },
      },
      {
        path: 'MonthWorkDetails',
        name: 'MonthWorkDetails',
        components: {
          mainPlaceholder: () => import('@/views/functionality/MonthWorkDetails.vue')
        },
        meta: { toolbarTitle: 'MonthWorkDetails.toolbarTitle' },
      },
      /**
       * request
       */
      {
        path: 'request-leave',
        name: 'request-leave',
        components: {
          mainPlaceholder: () => import('@/views/request/VacationRequest.vue')
        },
        meta: { toolbarTitle: 'nav-request-leave' },
      },
      {
        path: 'request-leave-archive',
        name: 'request-leave-archive',
        components: {
          mainPlaceholder: () => import('@/views/request/VacationArchive.vue'),
        },
        meta: { toolbarTitle: 'nav-request-leave-archive' },
      },
      {
        path: 'request-mission',
        name: 'request-mission',
        components: {
          mainPlaceholder: () => import('@/views/request/MissionRequest.vue'),
        },
        meta: { toolbarTitle: 'nav-request-mission' },
      },
      {
        path: 'addMissionHour',
        name: 'addMissionHour',
        components: {
          mainPlaceholder: () => import('@/views/request/AddMissionHour.vue'),
        },
        meta: { toolbarTitle: 'nav-mission-hour' },
      },
      {
        path: 'request-mission-archive',
        name: 'request-mission-archive',
        components: {
          mainPlaceholder: () => import('@/views/request/MissionArchive.vue'),
        },
        meta: { toolbarTitle: 'nav-request-mission-archive' },
      },
      {
        path: 'request-io',
        name: 'request-io',
        components: {
          mainPlaceholder: () => import('@/views/request/IORequest.vue'),
        },
        meta: { toolbarTitle: 'nav-request-io' },
      },
      {
        path: 'request-io-location',
        name: 'request-io-location',
        components: {
          mainPlaceholder: () => import('@/views/request/IORequestWithLocation.vue'),
        },
        meta: { toolbarTitle: 'nav-request-io-location' },
      },
      {
        path: 'request-io-archive',
        name: 'request-io-archive',
        components: {
          mainPlaceholder: () => import('@/views/request/IOArchive.vue'),
        },
        meta: { toolbarTitle: 'nav-request-io-archive' },
      },
      {
        path: 'request-extra-work',
        name: 'request-extra-work',
        components: {
          mainPlaceholder: () => import('@/views/request/ExtraWorkRequest.vue'),
        },
        meta: { toolbarTitle: 'nav-request-extra-work' },
      },
      {
        path: 'request-extra-work-archive',
        name: 'request-extra-work-archive',
        components: {
          mainPlaceholder: () => import('@/views/request/ExtraWorkArchive.vue'),
        },
        meta: { toolbarTitle: 'nav-request-extra-work-archive' },
      },
      {
        path: 'request-specific-extra-work-archive',
        name: 'request-specific-extra-work-archive',
        components: {
          mainPlaceholder: () => import('@/views/request/SpecificExtraWorkArchive.vue'),
        },
        meta: { toolbarTitle: 'nav-request-specific-extra-work-archive' },
      },
      /**
       * 
       */
      {
        path: 'private-cartable',
        name: 'private-cartable',
        components: {
          //default: EmptyView,
          mainPlaceholder: EmptyView,
        },
        meta: { toolbarTitle: 'nav-private-cartable' },
      },
      {
        path: 'report-conflict',
        name: 'report-conflict',
        components: {
          mainPlaceholder: () => import('@/views/conflict/ConflictReport.vue'),
        },
        meta: { toolbarTitle: 'nav-report-conflict' },
      },
      {
        path: 'change-password',
        name: 'change-password',
        components: {
          mainPlaceholder: () => import('@/views/pass/ChangePass.vue'),
        },
        meta: { toolbarTitle: 'nav-change-password' },
      },
      {
        path: 'settings',
        name: 'settings',
        components: {
          mainPlaceholder: () => import('@/views/settings/settings.vue'),
        },
        meta: { toolbarTitle: 'nav-settings' },
      },
      /**
       * Messages
       */
      {
        path: 'inbox',
        name: 'inbox',
        components: {
          //default: EmptyView,
          mainPlaceholder: () => import('@/views/messages/Inbox.vue'),
        },
        meta: { toolbarTitle: 'nav-inbox' },
      },
      {
        path: 'outbox',
        name: 'outbox',
        components: {
          //default: EmptyView,
          mainPlaceholder: () => import('@/views/messages/outbox.vue'),
        },
        meta: { toolbarTitle: 'nav-outbox' },
      },
      {
        path: 'send-message',
        name: 'send-message',
        components: {
          //default: EmptyView,
          mainPlaceholder: () => import('@/views/messages/SendMessage.vue'),
        },
        meta: { toolbarTitle: 'nav-send-message' },
      },
      /**
       * PersonelOperationReport
       */

      {
        path: 'present-personel',
        name: 'present-personel',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/PresentPersonel.vue'),
        },
        meta: { toolbarTitle: 'nav-present-personel' },
      },
      {
        path: 'ioinfoindate',
        name: 'ioinfoindate',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/IoInfoInDate.vue'),
        },
        meta: { toolbarTitle: 'nav-ioinfoindate' },
      },
      {
        path: 'personelioinfo',
        name: 'personelioinfo',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/PersonelIoInfo.vue'),
        },
        meta: { toolbarTitle: 'nav-personelioinfo' },
      },
      {
        path: 'personeldaywork',
        name: 'personeldaywork',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/PersonelDayWork.vue'),
        },
        meta: { toolbarTitle: 'nav-personeldaywork' },
      },
      {
        path: 'personelmonthwork',
        name: 'personelmonthwork',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/PersonelMonthWork.vue'),
        },
        meta: { toolbarTitle: 'nav-personelmonthwork' },
      },
      {
        path: 'personelperiodwork',
        name: 'personelperiodwork',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/PersonelPeriodWork.vue'),
        },
        meta: { toolbarTitle: 'nav-personelperiodwork' },
      },
      {
        path: 'personel-section',
        name: 'personel-section',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/SectionPersonel.vue'),
        },
        meta: { toolbarTitle: 'nav-personel-section' },
      },
      {
        path: 'personel-conflict-report',
        name: 'personel-conflict-report',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/PersonelConflictReport.vue'),
        },
        meta: { toolbarTitle: 'nav-personel-conflict-report' },
      },
      {
        path: 'absence-report',
        name: 'absence-report',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/AbsencePersonel.vue'),
        },
        meta: { toolbarTitle: 'nav-absence-report' },
      },
      {
        path: 'uncompleteio-report',
        name: 'uncompleteio-report',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/UnCompleteIOReport.vue'),
        },
        meta: { toolbarTitle: 'nav-uncompleteio-report' },
      },
      {
        path: 'extrawork-group-request',
        name: 'extrawork-group-request',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/ExtraWorkGroupRequest.vue'),
        },
        meta: { toolbarTitle: 'nav-extrawork-group-request' },
      },
      {
        path: 'compeleteio-specificdate',
        name: 'compeleteio-specificdate',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/CompleteIOInDate.vue'),
        },
        meta: { toolbarTitle: 'nav-compeleteio-specificdate' },
      },
      {
        path: 'compeleteio',
        name: 'compeleteio',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/CompleteIO.vue'),
        },
        meta: { toolbarTitle: 'nav-compeleteio' },
      },
      {
        path: 'attendance-status-report',
        name: 'attendance-status-report',
        components: {
          mainPlaceholder: () => import('../views/personelOperationReport/AttendanceStatusReport.vue'),
        },
        meta: { toolbarTitle: 'nav-attendance-status-report' },
      },
      /**
       * request-management
       */
      {
        path: 'vacation-management',
        name: 'vacation-management',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/VacationManagement.vue'),
        },
        meta: { toolbarTitle: 'nav-vacation-management' },
      },
      {
        path: 'mission-management',
        name: 'mission-management',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/MissionManagement.vue'),
        },
        meta: { toolbarTitle: 'nav-mission-management' },
      },
      {
        path: 'io-management',
        name: 'io-management',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/IOManagement.vue'),
        },
        meta: { toolbarTitle: 'nav-io-management' },
      },
      {
        path: 'extra-work-management',
        name: 'extra-work-management',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/ExtraWorkManagement.vue'),
        },
        meta: { toolbarTitle: 'nav-extra-work-management' },
      },
      {
        path: 'personel-vacation-view',
        name: 'personel-vacation-view',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/PersonelVacationView.vue'),
        },
        meta: { toolbarTitle: 'nav-personel-vacation-view' },
      },
      {
        path: 'personel-mission-view',
        name: 'personel-mission-view',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/PersonelMissionView.vue'),
        },
        meta: { toolbarTitle: 'nav-personel-mission-view' },
      },
      {
        path: 'personel-io-view',
        name: 'personel-io-view',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/PersonelIOView.vue'),
        },
        meta: { toolbarTitle: 'nav-personel-io-view' },
      },
      {
        path: 'personel-extrawork-view',
        name: 'personel-extrawork-view',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/PersonelExtraWorkView.vue'),
        },
        meta: { toolbarTitle: 'nav-personel-extrawork-view' },
      },
      {
        path: 'admin-approval-level-info',
        name: 'admin-approval-level-info',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/AdminApprovalLevelInfo.vue'),
        },
        meta: { toolbarTitle: 'nav-admin-approval-level-info' },
      },
      {
        path: 'specific-extrawork-request',
        name: 'specific-extrawork-request',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/SpecificExtraWorkRequest.vue'),
        },
        meta: { toolbarTitle: 'nav-specific-extrawork-request' },
      },
      {
        path: 'specific-extrawork-view',
        name: 'specific-extrawork-view',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/SpecificExtraWorkManagement.vue'),
        },
        meta: { toolbarTitle: 'nav-specific-extrawork-view' },
      },
      {
        path: 'aproved-Mission-view',
        name: 'aproved-Mission-view',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/ApprovedMission.vue'),
        },
        meta: { toolbarTitle: 'nav-aproved-Mission-view' },
      },
      {
        path: 'aproved-Vacation-view',
        name: 'aproved-Vacation-view',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/ApprovedVacation.vue'),
        },
        meta: { toolbarTitle: 'nav-aproved-Vacation-view' },
      },
      {
        path: 'aproved-ExtraWork-view',
        name: 'aproved-ExtraWork-view',
        components: {
          mainPlaceholder: () => import('../views/requestManagement/ApprovedExtraWork.vue'),
        },
        meta: { toolbarTitle: 'nav-aproved-ExtraWork-view' },
      },
      /** */
    ],
  },
  {
    path: '/config',
    name: 'config',
    component: () => import('../views/config/Config.vue'),
    meta: {
      toolbarTitle: 'nav-settings',
      //requiresAuth: true,
      //userRole: 'config'
    },
  },
  {
    path: '/rpIoInfo',
    name: 'rpIoInfo',
    component: () => import('../views/reports/rpIoInfo.vue'),
    meta: {
      toolbarTitle: 'nav-reports',
      requiresAuth: true,
    },
  },
  {
    path: '/rpPersonelsDayWork',
    name: 'rpPersonelsDayWork',
    component: () => import('../views/reports/rpPersonelsDayWork.vue'),
    meta: {
      toolbarTitle: 'nav-reports',
      requiresAuth: true,
    },
  },
  {
    path: '/rpPeresentPersonel',
    name: 'rpPeresentPersonel',
    component: () => import('../views/reports/rpPeresentPersonel.vue'),
    meta: {
      toolbarTitle: 'nav-reports',
      requiresAuth: true,
    },
  },
  {
    path: '/rpIOInDate',
    name: 'rpIOInDate',
    component: () => import('../views/reports/rpIOInDate.vue'),
    meta: {
      toolbarTitle: 'nav-reports',
      requiresAuth: true,
    },
  },
  {
    path: '/rpPersonelPeriodWork',
    name: 'rpPersonelPeriodWork',
    component: () => import('../views/reports/rpPersonelPeriodWork.vue'),
    meta: {
      toolbarTitle: 'nav-reports',
      requiresAuth: true,
    },
  },
  {
    path: '/rpPersonelsList',
    name: 'rpPersonelsList',
    component: () => import('../views/reports/rpPersonelsList.vue'),
    meta: {
      toolbarTitle: 'nav-reports',
      requiresAuth: true,
    },
  },
  {
    path: '/rpAbsence',
    name: 'rpAbsence',
    component: () => import('../views/reports/rpAbsence.vue'),
    meta: {
      toolbarTitle: 'nav-reports',
      requiresAuth: true,
    },
  },
  {
    path: '/rpPersonelUnCompletedIO',
    name: 'rpPersonelUnCompletedIO',
    component: () => import('../views/reports/rpPersonelUnCompletedIO.vue'),
    meta: {
      toolbarTitle: 'nav-reports',
      requiresAuth: true,
    },
  },
  {
    path: '/rpPersonelPeriodWorkDetail',
    name: 'rpPersonelPeriodWorkDetail',
    component: () => import('../views/reports/rpPersonelPeriodWorkDetail.vue'),
    meta: {
      toolbarTitle: 'nav-reports',
      requiresAuth: true,
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const DEFAULT_TITLE = 'Web Kart | ' +store.state.lock.customerName;
router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    console.log(store.state.lock.customerName);
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

// Auth Handling
router.beforeEach(async (to, from, next) => {
  //
  debugger
 
  await store.dispatch('getLocalConfig')
  // var token=store.getters.token;
 const isLoggedIn=store.state.auth.auth.token
  //
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //admin
    if (to.matched.some(record => record.meta.userRole == 'admin')) {
      if (EosUtils.isWebKartAdmin()) {
        next()
      } else {
        next({
          path: '/login',
          params: { nextUrl: to.fullPath }
        })
      }
    } else if (to.matched.some(record => record.meta.userRole == 'config')) {
      if (store.state.auth.auth.username === "000") {
        next()
      } else {
        next({
          path: '/login',
          params: { nextUrl: to.fullPath }
        })
      }
    } else {
      //manager
      if (store.state.auth.auth.username  ) {
        next()
      }
      else if(isLoggedIn){
        next()
      }
      // else if (to.path =='/login'&& store.state.auth.auth.username){
      //   next()
      // }
      else {
        next({
          path: '/login',
          params: { nextUrl: to.fullPath }
        })
      }
    }

  } else {
    next()
  }
})

export default router
